/**
 * Labstep
 *
 * @module prosemirror/nodes/jupyter-notebook
 * @desc JupyterNotebook node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'jupyter_notebook';

export const NodeJupyterNotebook: LabstepNode = {
  key,
  spec: {
    attrs: {
      id: { default: null },
      guid: { default: null },
    },
    group: 'block',
    marks: '',
    draggable: true,
    parseDOM: [{ tag: 'div', getAttrs: getAttrsForId(key) }],
    toDOM(node: ProseMirrorNode) {
      const { id } = node.attrs;
      return [
        'div',
        {
          [`data-${NodeJupyterNotebook.key}-id`]: id,
        },
      ];
    },
  },
};
